import { EventTypes } from '@store';
import { EventsData, EventsHistoryQueryParams, ViEvent } from '@vi-iot/client';

export class MockedEventList {
  constructor() {}

  private deviceErrorEvents: ViEvent[] = [
    {
      eventType: EventTypes.DEVICE_ERROR,
      gatewaySerial: '',
      body: {
        errorCode: 'ef',
        deviceId: '0',
        modelId: 'CU401B_S',
        active: true,
        equipmentType: 'Boiler',
        errorEventType: 'Error',
        errorDescription: 'Subscriber failure at the Modbus',
        errorMessage: undefined,
      },
      createdAt: new Date(new Date().getFullYear(), 0, 3, 12, 24, 0).toISOString(),
      eventTimestamp: new Date(new Date().getFullYear(), 0, 3, 12, 24, 0).toISOString(),
      editedBy: 'system',
    },
    {
      eventType: EventTypes.DEVICE_ERROR,
      gatewaySerial: '',
      body: {
        errorCode: 'ef',
        deviceId: '0',
        modelId: 'CU401B_S',
        active: false,
        equipmentType: 'Boiler',
        errorEventType: 'Error',
        errorDescription: 'Subscriber failure at the Modbus',
        errorMessage: undefined,
      },
      createdAt: new Date(new Date().getFullYear(), 0, 3, 12, 28, 0).toISOString(),
      eventTimestamp: new Date(new Date().getFullYear(), 0, 3, 12, 28, 0).toISOString(),
      editedBy: 'system',
    },
  ];

  private deviceWarningEvents: ViEvent[] = [
    {
      eventType: EventTypes.DEVICE_MESSAGE_WARNING,
      gatewaySerial: '',
      body: {
        errorCode: 'A.106',
        deviceId: '0',
        modelId: 'E3_VitoCharge_0122',
        active: true,
        equipmentType: 'Boiler',
        errorEventType: undefined,
        errorDescription: 'A.106',
        errorMessage: undefined,
      },
      createdAt: new Date(new Date().getFullYear(), 0, 5, 17, 43, 0).toISOString(),
      eventTimestamp: new Date(new Date().getFullYear(), 0, 5, 17, 43, 0).toISOString(),
      editedBy: 'system',
    },
    {
      eventType: EventTypes.DEVICE_MESSAGE_WARNING,
      gatewaySerial: '',
      body: {
        errorCode: 'A.106',
        deviceId: '0',
        modelId: 'E3_VitoCharge_0122',
        active: false,
        equipmentType: 'Boiler',
        errorEventType: undefined,
        errorDescription: 'A.106',
        errorMessage: undefined,
      },
      createdAt: new Date(new Date().getFullYear(), 0, 5, 17, 47, 0).toISOString(),
      eventTimestamp: new Date(new Date().getFullYear(), 0, 5, 17, 47, 0).toISOString(),
      editedBy: 'system',
    },
  ];

  private deviceServiceMessageEvents: ViEvent[] = [
    this.createEmptyEvent(
      EventTypes.DEVICE_MESSAGE_SERVICE,
      new Date(new Date().getFullYear(), 0, 12, 4, 12, 0).toISOString()
    ),
  ];

  private deviceInfoMessageEvents: ViEvent[] = [
    {
      eventType: EventTypes.DEVICE_MESSAGE_INFO,
      gatewaySerial: '',
      body: {
        errorCode: 'I.78',
        deviceId: '0',
        modelId: 'E3_Vitocal',
        active: true,
        equipmentType: 'Boiler',
        errorEventType: undefined,
        errorDescription: 'I.78',
        errorMessage: undefined,
      },
      createdAt: new Date(new Date().getFullYear(), 1, 7, 21, 27, 0).toISOString(),
      eventTimestamp: new Date(new Date().getFullYear(), 1, 7, 21, 27, 0).toISOString(),
      editedBy: 'system',
    },
    {
      eventType: EventTypes.DEVICE_MESSAGE_INFO,
      gatewaySerial: '',
      body: {
        errorCode: 'I.78',
        deviceId: '0',
        modelId: 'E3_Vitocal',
        active: false,
        equipmentType: 'Boiler',
        errorEventType: undefined,
        errorDescription: 'I.78',
        errorMessage: undefined,
      },
      createdAt: new Date(new Date().getFullYear(), 1, 7, 21, 30, 0).toISOString(),
      eventTimestamp: new Date(new Date().getFullYear(), 1, 7, 21, 30, 0).toISOString(),
      editedBy: 'system',
    },
  ];

  private deviceStatusMessageEvents: ViEvent[] = [
    {
      eventType: EventTypes.DEVICE_MESSAGE_STATUS,
      gatewaySerial: '',
      body: {
        errorCode: 'S.115',
        deviceId: '0',
        modelId: 'E3_Vitocal',
        active: true,
        equipmentType: 'Boiler',
        errorEventType: undefined,
        errorDescription: 'A.115',
        errorMessage: undefined,
      },
      createdAt: new Date(new Date().getFullYear(), 1, 21, 9, 13, 0).toISOString(),
      eventTimestamp: new Date(new Date().getFullYear(), 1, 21, 9, 13, 0).toISOString(),
      editedBy: 'system',
    },
    {
      eventType: EventTypes.DEVICE_MESSAGE_STATUS,
      gatewaySerial: '',
      body: {
        errorCode: 'S.115',
        deviceId: '0',
        modelId: 'E3_Vitocal',
        active: false,
        equipmentType: 'Boiler',
        errorEventType: undefined,
        errorDescription: 'A.115',
        errorMessage: undefined,
      },
      createdAt: new Date(new Date().getFullYear(), 1, 21, 9, 15, 0).toISOString(),
      eventTimestamp: new Date(new Date().getFullYear(), 1, 21, 9, 15, 0).toISOString(),
      editedBy: 'system',
    },
  ];

  private heatingRodEvents: ViEvent[] = [
    this.createEmptyEvent(
      EventTypes.HEATING_ROD_RUN_TOO_LONG,
      new Date(new Date().getFullYear(), 1, 23, 19, 2, 0).toISOString()
    ),
  ];

  private viFlexEvent: ViEvent[] = [
    {
      eventType: EventTypes.VIFLEX,
      gatewaySerial: '',
      body: {
        startTime: new Date(new Date().getFullYear(), 1, 24, 11, 7, 0).toISOString(),
        endTime: new Date(new Date().getFullYear(), 1, 24, 11, 8, 0).toISOString(),
      },
      createdAt: new Date(new Date().getFullYear(), 1, 24, 11, 7, 0).toISOString(),
      eventTimestamp: new Date(new Date().getFullYear(), 1, 24, 11, 7, 0).toISOString(),
      editedBy: 'Viessmann',
    },
  ];

  private dynamicSavingTipsHeatingcurveSavingsEvent: ViEvent[] = [
    {
      eventType: EventTypes.DYNAMIC_SAVING_TIPS_HEATINGCURVE_SAVINGS,
      gatewaySerial: '',
      body: {
        installationId: 1,
        gatewaySerial: '',
        deviceId: '0',
        savingPotentialAbsolute: 5,
        savingPotentialRelative: 10,
      },
      createdAt: new Date(new Date().getFullYear(), 1, 26, 17, 4, 0).toISOString(),
      eventTimestamp: new Date(new Date().getFullYear(), 1, 26, 17, 4, 0).toISOString(),
      editedBy: 'system',
    },
  ];

  private setbackDurationCanBeIncreasedByOneHour: ViEvent[] = [
    {
      eventType: EventTypes.SETBACK_DURATION_CAN_BE_INCREASED_BY_ONE_HOUR,
      gatewaySerial: '',
      body: {
        installationId: 1,
        gatewaySerial: '',
        deviceId: '0',
        savingPotentialAbsolute: 3,
        savingPotentialRelative: 6,
      },
      createdAt: new Date(new Date().getFullYear(), 1, 26, 17, 12, 0).toISOString(),
      eventTimestamp: new Date(new Date().getFullYear(), 1, 26, 17, 12, 0).toISOString(),
      editedBy: 'system',
    },
  ];

  private dhwTargetTemperatureCanBeDecreasedEvent: ViEvent[] = [
    {
      eventType: EventTypes.DHW_TARGET_TEMPERATURE_CAN_BE_DECREASED,
      gatewaySerial: '',
      body: {
        installationId: 1,
        gatewaySerial: '',
        deviceId: '0',
        savingPotentialAbsolute: 4,
        savingPotentialRelative: 8,
        temperatureRecommended: 45,
        temperatureCurrent: 50,
      },
      createdAt: new Date(new Date().getFullYear(), 1, 26, 17, 20, 0).toISOString(),
      eventTimestamp: new Date(new Date().getFullYear(), 1, 26, 17, 20, 0).toISOString(),
      editedBy: 'system',
    },
  ];

  private dhwDurationCanBeDecreasedEvent: ViEvent[] = [
    {
      eventType: EventTypes.DHW_DURATION_CAN_BE_DECREASED,
      gatewaySerial: '',
      body: {
        installationId: 1,
        gatewaySerial: '',
        deviceId: '0',
        savingPotentialAbsolute: 5,
        savingPotentialRelative: 10,
        durationRecommended: 1200,
        durationCurrent: 990,
      },
      createdAt: new Date(new Date().getFullYear(), 1, 26, 17, 23, 0).toISOString(),
      eventTimestamp: new Date(new Date().getFullYear(), 1, 26, 17, 23, 0).toISOString(),
      editedBy: 'system',
    },
  ];

  private gatewayOnlineEvents: ViEvent[] = [
    {
      eventType: EventTypes.GATEWAY_ONLINE,
      gatewaySerial: '',
      body: {
        online: false,
      },
      createdAt: new Date(new Date().getFullYear(), 2, 3, 11, 12, 0).toISOString(),
      eventTimestamp: new Date(new Date().getFullYear(), 2, 3, 11, 12, 0).toISOString(),
      editedBy: 'system',
    },
    {
      eventType: EventTypes.GATEWAY_ONLINE,
      gatewaySerial: '',
      body: {
        online: true,
      },
      createdAt: new Date(new Date().getFullYear(), 2, 3, 11, 42, 0).toISOString(),
      eventTimestamp: new Date(new Date().getFullYear(), 2, 3, 11, 42, 0).toISOString(),
      editedBy: 'system',
    },
  ];

  private firmwareUpdateStatusEvents: ViEvent[] = [
    {
      eventType: EventTypes.FIRMWARE_UPDATE_STATUS,
      gatewaySerial: '',
      body: {
        firmwareVersion: {
          major: 1,
          minorRevision: 2,
          minor: 3,
          build: 5426,
          majorRevision: 5,
          revision: 1,
        },
      },
      createdAt: new Date(new Date().getFullYear(), 2, 9, 16, 2, 0).toISOString(),
      eventTimestamp: new Date(new Date().getFullYear(), 2, 9, 16, 2, 0).toISOString(),
      editedBy: 'system',
    },
  ];

  private gatewayResetCommandEvents: ViEvent[] = [
    this.createEmptyEvent(
      EventTypes.GATEWAY_RESET_COMMAND,
      new Date(new Date().getFullYear(), 2, 9, 16, 19, 0).toISOString()
    ),
  ];

  private featureChangedEvents: ViEvent[] = [
    {
      eventType: EventTypes.FEATURE_CHANGED,
      gatewaySerial: '',
      body: {
        featureName: 'heating.dhw.oneTimeCharge',
        commandName: 'activate',
        commandBody: {},
      },
      createdAt: new Date(new Date().getFullYear(), 3, 1, 7, 5, 0).toISOString(),
      eventTimestamp: new Date(new Date().getFullYear(), 3, 1, 7, 5, 0).toISOString(),
      editedBy: 'Viessmann',
    },
    {
      eventType: EventTypes.FEATURE_CHANGED,
      gatewaySerial: '',
      body: {
        featureName: 'heating.dhw.temperature.main',
        commandName: 'setTargetTemperature',
        commandBody: {
          temperature: 45,
        },
      },
      createdAt: new Date(new Date().getFullYear(), 3, 1, 7, 25, 0).toISOString(),
      eventTimestamp: new Date(new Date().getFullYear(), 3, 1, 7, 25, 0).toISOString(),
      editedBy: 'Viessmann',
    },
    {
      eventType: EventTypes.FEATURE_CHANGED,
      gatewaySerial: '',
      body: {
        featureName: 'heating.dhw.heating.circuits.0.operating.modes.active',
        commandName: 'setMode',
        commandBody: {
          mode: 'dhwAndHeatingCooling',
        },
      },
      createdAt: new Date(new Date().getFullYear(), 3, 11, 12, 37, 0).toISOString(),
      eventTimestamp: new Date(new Date().getFullYear(), 3, 11, 12, 37, 0).toISOString(),
      editedBy: 'Viessmann',
    },
    {
      eventType: EventTypes.FEATURE_CHANGED,
      gatewaySerial: '7637415001664187',
      body: {
        featureName: 'gateway.status',
        commandName: 'clearCacheAndReboot',
      },
      createdAt: new Date(new Date().getFullYear(), 3, 11, 12, 37, 0).toISOString(),
      eventTimestamp: new Date(new Date().getFullYear(), 3, 11, 12, 37, 0).toISOString(),
      editedBy: 'Viessmann',
    },
  ];

  private snapshotRestoreStatusChangedEvents: ViEvent[] = [
    this.createEmptyEvent(
      EventTypes.SNAPSHOT_RESTORE_STATUS_CHANGED,
      new Date(new Date().getFullYear(), 3, 19, 23, 57, 0).toISOString()
    ),
  ];

  private srcStatusChangedEvents: ViEvent[] = [
    this.createEmptyEvent(
      EventTypes.SRC_STATUS_CHANGED,
      new Date(new Date().getFullYear(), 3, 22, 14, 20, 0).toISOString(),
      false
    ),
    this.createEmptyEvent(
      EventTypes.SRC_STATUS_CHANGED,
      new Date(new Date().getFullYear(), 3, 22, 14, 25, 0).toISOString()
    ),
  ];

  private geofencingActivationChangedEvents: ViEvent[] = [
    this.createEmptyEvent(
      EventTypes.GEOFENCING_ACTIVATION_CHANGED,
      new Date(new Date().getFullYear(), 3, 22, 14, 40, 0).toISOString(),
      false
    ),
    this.createEmptyEvent(
      EventTypes.GEOFENCING_ACTIVATION_CHANGED,
      new Date(new Date().getFullYear(), 3, 22, 14, 42, 0).toISOString()
    ),
  ];

  private bmuSerialChangedEvents: ViEvent[] = [
    {
      eventType: EventTypes.DEVICE_BMU_SERIAL_CHANGED,
      gatewaySerial: '',
      body: {
        deviceId: '0',
        modelId: 'CU401B_S',
        bmuSerial: '1234567890123456',
        editor: 'DeviceCommunication',
      },
      createdAt: new Date(new Date().getFullYear(), 4, 2, 19, 23, 0).toISOString(),
      eventTimestamp: new Date(new Date().getFullYear(), 4, 2, 19, 23, 0).toISOString(),
      editedBy: 'system',
    },
  ];

  private boilerSerialChangedEvents: ViEvent[] = [
    {
      eventType: EventTypes.DEVICE_BOILER_SERIAL_CHANGED,
      gatewaySerial: '',
      body: {
        deviceId: '0',
        modelId: 'CU401B_S',
        boilerSerial: '1234567890123456',
        editor: 'DeviceCommunication',
      },
      createdAt: new Date(new Date().getFullYear(), 4, 2, 19, 27, 0).toISOString(),
      eventTimestamp: new Date(new Date().getFullYear(), 4, 2, 19, 27, 0).toISOString(),
      editedBy: 'system',
    },
  ];

  private installationAddressChangedEvents: ViEvent[] = [
    {
      eventType: EventTypes.INSTALLATION_ADDRESS_CHANGED,
      gatewaySerial: '',
      body: {
        caller: 'Owner',
      },
      createdAt: new Date(new Date().getFullYear(), 4, 2, 19, 32, 0).toISOString(),
      eventTimestamp: new Date(new Date().getFullYear(), 4, 2, 19, 32, 0).toISOString(),
      editedBy: 'system',
    },
  ];

  private invitationAcceptedEvents: ViEvent[] = [
    {
      eventType: EventTypes.INVITATION_ACCEPTED,
      gatewaySerial: '',
      body: {
        inviter: 'Owner',
        invitee: 'Maintainer',
      },
      createdAt: new Date(new Date().getFullYear(), 4, 3, 9, 45, 0).toISOString(),
      eventTimestamp: new Date(new Date().getFullYear(), 4, 3, 9, 45, 0).toISOString(),
      editedBy: 'system',
    },
  ];

  private invitationTerminatedEvents: ViEvent[] = [
    {
      eventType: EventTypes.INVITATION_TERMINATED,
      gatewaySerial: '',
      body: {
        inviter: 'Owner',
        invitee: 'Builder',
      },
      createdAt: new Date(new Date().getFullYear(), 4, 5, 8, 12, 0).toISOString(),
      eventTimestamp: new Date(new Date().getFullYear(), 4, 5, 8, 12, 0).toISOString(),
      editedBy: 'system',
    },
  ];

  mock(params: EventsHistoryQueryParams): EventsData {
    const selectedEvents: string[] = params.eventType instanceof Array ? params.eventType : [];
    let responseData: ViEvent[] = [];

    if (!selectedEvents.length) {
      responseData = responseData.concat(
        this.deviceErrorEvents,
        this.deviceWarningEvents,
        this.deviceServiceMessageEvents,
        this.deviceInfoMessageEvents,
        this.deviceStatusMessageEvents,
        this.heatingRodEvents,
        this.viFlexEvent,
        this.dynamicSavingTipsHeatingcurveSavingsEvent,
        this.setbackDurationCanBeIncreasedByOneHour,
        this.dhwTargetTemperatureCanBeDecreasedEvent,
        this.dhwDurationCanBeDecreasedEvent,
        this.gatewayOnlineEvents,
        this.firmwareUpdateStatusEvents,
        this.gatewayResetCommandEvents,
        this.featureChangedEvents,
        this.snapshotRestoreStatusChangedEvents,
        this.srcStatusChangedEvents,
        this.geofencingActivationChangedEvents,
        this.bmuSerialChangedEvents,
        this.boilerSerialChangedEvents,
        this.installationAddressChangedEvents,
        this.invitationAcceptedEvents,
        this.invitationTerminatedEvents
      );
    } else {
      selectedEvents.forEach((selectedEvent) => {
        switch (selectedEvent) {
          // SYSTEM_MESSAGES
          case EventTypes.DEVICE_ERROR:
            return (responseData = responseData.concat(this.deviceErrorEvents));
          case EventTypes.DEVICE_MESSAGE_WARNING:
            return (responseData = responseData.concat(this.deviceWarningEvents));
          case EventTypes.DEVICE_MESSAGE_SERVICE:
            return (responseData = responseData.concat(this.deviceServiceMessageEvents));
          case EventTypes.DEVICE_MESSAGE_INFO:
            return (responseData = responseData.concat(this.deviceInfoMessageEvents));
          case EventTypes.DEVICE_MESSAGE_STATUS:
            return (responseData = responseData.concat(this.deviceStatusMessageEvents));
          case EventTypes.HEATING_ROD_RUN_TOO_LONG:
            return (responseData = responseData.concat(this.heatingRodEvents));
          case EventTypes.VIFLEX:
            return (responseData = responseData.concat(this.viFlexEvent));
          case EventTypes.DYNAMIC_SAVING_TIPS_HEATINGCURVE_SAVINGS:
            return (responseData = responseData.concat(
              this.dynamicSavingTipsHeatingcurveSavingsEvent
            ));
          case EventTypes.SETBACK_DURATION_CAN_BE_INCREASED_BY_ONE_HOUR:
            return (responseData = responseData.concat(
              this.setbackDurationCanBeIncreasedByOneHour
            ));
          case EventTypes.DHW_TARGET_TEMPERATURE_CAN_BE_DECREASED:
            return (responseData = responseData.concat(
              this.dhwTargetTemperatureCanBeDecreasedEvent
            ));
          case EventTypes.DHW_DURATION_CAN_BE_DECREASED:
            return (responseData = responseData.concat(this.dhwDurationCanBeDecreasedEvent));
          // COMMUNICATION_MODULE
          case EventTypes.GATEWAY_ONLINE:
            return (responseData = responseData.concat(this.gatewayOnlineEvents));
          case EventTypes.FIRMWARE_UPDATE_STATUS:
            return (responseData = responseData.concat(this.firmwareUpdateStatusEvents));
          case EventTypes.GATEWAY_RESET_COMMAND:
            return (responseData = responseData.concat(this.gatewayResetCommandEvents));
          // SETTINGS
          case EventTypes.FEATURE_CHANGED:
            return (responseData = responseData.concat(this.featureChangedEvents));
          case EventTypes.SNAPSHOT_RESTORE_STATUS_CHANGED:
            return (responseData = responseData.concat(this.snapshotRestoreStatusChangedEvents));
          case EventTypes.SRC_STATUS_CHANGED:
            return (responseData = responseData.concat(this.srcStatusChangedEvents));
          case EventTypes.GEOFENCING_ACTIVATION_CHANGED:
            return (responseData = responseData.concat(this.geofencingActivationChangedEvents));
          // INSTALLATION_DATA
          case EventTypes.DEVICE_BMU_SERIAL_CHANGED:
            return (responseData = responseData.concat(this.bmuSerialChangedEvents));
          case EventTypes.DEVICE_BOILER_SERIAL_CHANGED:
            return (responseData = responseData.concat(this.boilerSerialChangedEvents));
          case EventTypes.INSTALLATION_ADDRESS_CHANGED:
            return (responseData = responseData.concat(this.installationAddressChangedEvents));
          // INVITATIONS
          case EventTypes.INVITATION_ACCEPTED:
            return (responseData = responseData.concat(this.invitationAcceptedEvents));
          case EventTypes.INVITATION_TERMINATED:
            return (responseData = responseData.concat(this.invitationTerminatedEvents));
        }
      });
    }

    if (params.timestamp) {
      responseData = responseData.filter((event) => event.eventTimestamp >= params.timestamp);
    }

    return {
      data: responseData,
      cursor: {
        next: '',
      },
    };
  }

  private createEmptyEvent(eventType: EventTypes, date: string, active: boolean = true) {
    return {
      eventType: eventType,
      gatewaySerial: '',
      body: {
        errorCode: undefined,
        deviceId: undefined,
        modelId: undefined,
        active: active,
        equipmentType: undefined,
        errorEventType: undefined,
        errorDescription: undefined,
        errorMessage: undefined,
      },
      createdAt: date,
      eventTimestamp: date,
      editedBy: 'system',
    };
  }
}
